import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Button, ListGroup, Row, Col } from 'react-bootstrap';
import { getLayouts, deleteLayout } from '../../services/api';

function LayoutList() {
    const [layouts, setLayouts] = useState([]);

    useEffect(() => {
        fetchLayouts();
    }, []);

    const fetchLayouts = async () => {
        try {
            const response = await getLayouts();
            setLayouts(response.data.layouts);
        } catch (error) {
            console.error("Errore nel caricamento dei layout", error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Sei sicuro di voler eliminare questo layout?')) {
            try {
                await deleteLayout(id);
                fetchLayouts(); // Ricarica la lista dopo l'eliminazione
            } catch (error) {
                console.error("Errore nell'eliminazione del layout", error);
            }
        }
    };

    return (
        <Container>
            <Row className="align-items-center mb-3">
                <Col>
                    <h1>Layout di Stampa</h1>
                </Col>
                <Col xs="auto">
                    <Link to="/layouts/new">
                        <Button variant="primary">
                            Nuovo Layout
                        </Button>
                    </Link>
                </Col>
            </Row>
            
            <ListGroup>
                {layouts.map(layout => (
                    <ListGroup.Item key={layout.id}>
                        <Row className="align-items-center">
                            <Col>
                                <h5>{layout.nome}</h5>
                                <small className="text-muted">Modulo: {layout.modulo}</small>
                            </Col>
                            <Col xs="auto">
                                <Link to={`/layouts/edit/${layout.id}`}>
                                    <Button variant="outline-secondary" size="sm" className="me-2">
                                        Modifica
                                    </Button>
                                </Link>
                                <Button variant="outline-danger" size="sm" onClick={() => handleDelete(layout.id)}>
                                    Elimina
                                </Button>
                            </Col>
                        </Row>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </Container>
    );
}

export default LayoutList;